// extracted by mini-css-extract-plugin
module.exports = {"text_change":"sleep-elixir-pdp_text_change__WtNEh"};